/** Classe contant le css */
export interface ICssClass {
    CssClass: string;
    LogicalExpression: string;
}

export class CssClass implements ICssClass {
    private _cssClass: string;
    private _logicalExpression: string;

    public constructor(data: Partial<CssClass>) {
        this._cssClass = data?.CssClass ?? undefined;
        this._logicalExpression = data?.LogicalExpression ?? "true";
    }

    get CssClass(): string {
        return this._cssClass;
    }

    public set CssClass(value: string) {
        this._cssClass = value;
    }

    get LogicalExpression(): string {
        return this._logicalExpression;
    }

    public set LogicalExpression(value: string) {
        this._logicalExpression = value;
    }
}